import React from 'react';
import Image from 'next/image';
import { motion } from 'framer-motion';
import usersvg from "../../public/svg/increse-productivity.svg";
import decreasetimeline from "../../public/svg/decrease-timeline.svg";
import geographicalbarrier from "../../public/svg/geographical-barrier.svg"
import lowcostcampushiring from "../../public/svg/low-cost-campus-hiring.svg";
import analyticsandinsigts from "../../public/svg/analytics-and-insigts.svg";
import reductionenergyloss from "../../public/svg/reduction-energy-loss.svg";

const carddata = [
  { card: 1, src: usersvg, alt: 'automated recruiting software', boldtext: "60%", text: 'increase in productivity', content: "lorem Ipsum content", backgroundColor: "#ffe3e1" },
  { card: 2, src: decreasetimeline, alt: 'virtual recruitment platform', boldtext: "60%", text: 'decrease in timeline', content: "lorem Ipsum content", backgroundColor: "#daebff" },
  { card: 3, src: geographicalbarrier, alt: 'virtual interview platforms', boldtext: "No", text: 'geographical barrier', content: "lorem Ipsum content", backgroundColor: "#fee6d9" },
  { card: 4, src: lowcostcampushiring, alt: 'interview prep website', boldtext: "75% ", text: 'reduction in hiring cost', content: "lorem Ipsum content", backgroundColor: "#daebff" },
  { card: 5, src: reductionenergyloss, alt: 'preparation for a mock interview', boldtext: "70% ", text: 'reduction in energy loss', content: "lorem Ipsum content", backgroundColor: "#d8f5da" },
  { card: 6, src: analyticsandinsigts, alt: 'online interview preparation', boldtext: "Improved", text: 'insights and analytics', content: "lorem Ipsum content", backgroundColor: "#ffe3e1" }
];

const Solutionsachivement = () => {
  return (
    <div className='2xl:mx-24 xl:mx-20 lg:mx-24 md:mx-20 sm:mx-10 mx-5 mb-20 px-14 z-10 relative'>
         <motion.h4
        initial={{ y: 50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{
          delay: 0.2,
          y: { type: "spring", stiffness: 60 },
          opacity: { duration: 0.2 },
          ease: "easeIn",
          duration: 1
        }}
        className='text-center lg:text-3xl text-[14px] mb-1 font-normal text-[#41b8ea]'>REDUCE YOUR TIME, ENERGY, AND COST.</motion.h4>
      <motion.h2
        initial={{ y: -50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{
          delay: 0.2,
          y: { type: "spring", stiffness: 60 },
          opacity: { duration: 0.2 },
          ease: "easeIn",
          duration: 1
        }}
        className='lg:text-4xl text-base text-center font-extrabold'>Unlock your true potential with our most comprehensive platform.</motion.h2>
    <div className='flex justify-center items-center'>
      <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5 mt-5'>
        {carddata.map(item => (
          <div key={item.card} className="accomplished-cards">
            <div className="cardcircle" style={{ backgroundColor: item.backgroundColor }}></div>
            <Image src={item.src} alt={item.alt} width="60" height="60" className='z-10 h-[80px] w-[80px]' />
            <h5
              className="accomplished-content lg:p-5 p-2 lg:mt-24 mt-[94px] text-center lg:text-[17px]"
              style={{
                transition: 'background-color 0.2s ease',
              }}

            >
              <span className='font-bold lg:text-lg text-sm'>{item.boldtext}</span>{" "}{item.text}
            </h5>
            {/* <p className='accomplished-content text-sm'>{item.content}</p> */}
          </div>
        ))}
      </div>
      </div>
    </div>
  );
}

export default Solutionsachivement;
